import React, { useState, useEffect } from "react";
import queryString from "query-string";
import ReportFormV3 from "./ReportFormV3";
import ReportForm2ndPartV3 from "./ReportForm2ndPartV3";
import VipNewebpay from "./VipNewebpay";
import VipJumbotronV3 from "./VipJumbotronV3";
import VipMaintenanceBulletin from "../VipMaintenanceBulletin";
import axios from "axios";
import { isUserAuthenticated } from "../helpers/authUtils";

const VipWireReportHomeV3 = ({ match, location }) => {
  const gameId = match.params.game_id;
  const [maintenance, setMaintenance] = useState(true);
  const [maintenanceBulletin, setMaintenanceBulletin] = useState(null);

  useEffect(() => {
    async function fetchMaintenanceBulletin() {
      const result = await axios(`/api/vipv3/maintenance`);
      
      if (result.data.msg==="OK") {
        setMaintenanceBulletin(result.data.bulletin);
      } else {
        setMaintenance(false);
      }
    }
    fetchMaintenanceBulletin();
   
  }, []);

  const [prevReport, setPrevReport] = useState({});

  useEffect(() => {
    async function fetchExistingReport(token) {
      try {
        const result = await axios(`/api/vipv2/prev_report/${token}`);
        //console.log("result", result.data.record);
        setPrevReport(result.data.record);
      } catch (error) {
        console.error(error);
      }
    }

    async function fetchMemberData(token) {
      try {
        const config = {
          headers: { 'x-auth-token': token },
        };
        const result = await axios(`/api/auth/get_member_data`, config);
        //console.log("result", result.data);
        setPrevReport(result.data);
      } catch (error) {
        //console.error(error);
      }
    }

    const search_values = queryString.parse(location.search);
    if (search_values.token) {
      fetchExistingReport(search_values.token);
    } else { 
      const isAuthTokenValid = isUserAuthenticated();
      if (isAuthTokenValid) {
        fetchMemberData(isAuthTokenValid);
      }
    }
  }, [location.search]); // Or [] if effect doesn't need props or state

  const [productsOption, setProductsOption] = useState([]);
  const [gift, setGift] = useState(null);
  const [donateOption, setDonateOption] = useState({});

  useEffect(() => {
    async function fetchGamesData(gameId) {
      const result = await axios(`/api/vipv3/game/${gameId}`);
      //console.log("result", result.data.os);
      if (result.data.os!==1) {
        window.location.replace('/game');
      }
    }
    fetchGamesData(gameId);

    async function fetchProductsData(gameId) {
      const result = await axios(`/api/vip/products/${gameId}`);
      //console.log("result", result.data.products);
      setProductsOption(result.data.products);
    }
    fetchProductsData(gameId);

    async function fetchGiftData(gameId) {
      const result = await axios(`/api/vipv2/gift/${gameId}`);
      //console.log("result", result.data.gift);
      setGift(result.data.gift);
    }
    fetchGiftData(gameId);

    async function fetchDonateData() {
      const result = await axios(`/api/vipv3/get_donate`);
      //console.log("result", result.data.donate_option);
      setDonateOption(result.data.donate_option);
    }
    fetchDonateData();
  }, [gameId]); // Or [] if effect doesn't need props or state

  //const [logData, setLogData] = useState({ report_id: "VP20200825111008wvg" });
  const [logData, setLogData] = useState({});
  const [resultData, setResultData] = useState({});

  if (resultData.TradeInfo) {
    return <VipNewebpay record={resultData} />;
  }

  const submitLog = (log) => {
    //e.preventDefault();

    //console.log("submitLog", log);
    //msg: "OK", record: log
    axios
      .post("/api/vipv2/first_step", log)
      .then((res) => {
        //console.log(res.data);

        setLogData(res.data?.record);
      })
      .catch((err) => console.log(err.message));
  };
  const submitWireReport = (report) => {
    //e.preventDefault();

    //console.log("submitLog", log);
    //msg: "OK", record: log

    axios
      .post("/api/vipv3/createReport", {
        ...report,
        report_id: logData.report_id,
      })
      .then((res) => {
        //console.log(res.data);

        setResultData(res.data?.record);
      })
      .catch((err) => console.log(err.message));
  };

  if (maintenance) {
    return <VipMaintenanceBulletin game_id={gameId} maintenanceBulletin={maintenanceBulletin} />
  }
  
  return (
    <div className="container">
      <VipJumbotronV3 game_id={gameId} products={productsOption} gift={gift} area="os" />
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6 col-sm-12 mt-3">
          {logData.report_id ? (
            <ReportForm2ndPartV3
              gameId={gameId}
              onSubmitReport={submitWireReport}
              products={productsOption}
              donateOption={donateOption}
            />
          ) : (
            <ReportFormV3
              gameId={gameId}
              onNextStepClick={submitLog}
              prevReport={prevReport}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default VipWireReportHomeV3;
